import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { getBacktestingResults, deleteBacktestingResult } from "../../../../api/backtestingResult";
import { Visibility } from "@material-ui/icons";

export default function BacktestingResultsPage() {
  const [data, setData] = useState([]);
  const [backtestingResultId, setBacktestingResultId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [backtestingResults, setBacktestingResults] = useState([]);

  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  function buttonFormatter(cell) {
    const elem = data.find((item) => item._id === cell);
    return (
      <>
        {!elem?.generating && (
          <>
            <Tooltip title="View">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => history.push("/edit-backtesting-results/" + cell)}
              >
                <Visibility />
              </Button>
            </Tooltip>
          </>
        )}
        {user?.role === "admin" && !elem?.isMain && (
          <>
            
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setBacktestingResultId(elem);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  const columns = [
    { dataField: "fullName", text: "Full name" },
    { 
      dataField: "_id", 
      text: "", 
      formatter: buttonFormatter, 
      headerStyle: {width: '150px'} 
    },
  ];

  useEffect(() => {
    getBacktestingResults()
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setBacktestingResults(res.data);
          setRefresh(false);
        }
      })
      .catch((error) => {
        if (error?.request?.status !== 404) 
          alertError({ error, customMessage: "Could not get backtestingResults." });
      });
  }, [refresh]);

  function getData(results) {

    function sortByFinishedAt(a, b) {
      if (a.finishedAt > b.finishedAt) return -1
      if (a.finishedAt < b.finishedAt) return 1
      return 0;
    }

    let data = [];

    for (let i = 0; i < results?.length; ++i) {
      const actR = results[i];
      let elem = { ...actR };
      if (!elem?.config?.fullName) {
        elem.fullName = "Error";
        if (!elem.finishedAt) elem.finishedAt = new Date();
      }
      else {
        let name = `De la configuración ${elem.config.fullName}`
        if (elem.finishedAt) name += ` finalizada en ${dateFormatter(elem.finishedAt)}`
        else {name += ` PENDIENTE DE FINALIZAR desde el ${dateFormatter(elem.createdAt)}...`; elem.finishedAt = new Date();}
        elem.fullName = name;
      }
      data.push(elem);
    }

    data.sort(sortByFinishedAt);

    return data;
  } 

  return (
    <>
      <Card>
        <CardHeader title="Backtesting results list">
          
        </CardHeader>
        <CardBody>

          <Table data={getData(backtestingResults)} columns={columns} />
          
          <ConfirmDialog
            title={"Are you sure you want to remove this backtestingResult?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteBacktestingResult(backtestingResultId._id)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "backtestingResult removed successfully.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not remove backtestingResult.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
